import { render, staticRenderFns } from "./PhoneLog.vue?vue&type=template&id=06cd834b&scoped=true"
import script from "./PhoneLog.vue?vue&type=script&lang=js"
export * from "./PhoneLog.vue?vue&type=script&lang=js"
import style0 from "./PhoneLog.vue?vue&type=style&index=0&id=06cd834b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd834b",
  null
  
)

export default component.exports